import { alpha, useTheme } from "@mui/material";
import { PieTooltipProps, ResponsivePie } from "@nivo/pie";
import { orderBy } from "lodash";
import useChartTheme from "./chartTheme";

type Props = {
  data: PizzaData[];
  formatTooltip: (point: PieTooltipProps<PizzaData>) => JSX.Element;
  colorTheme: "positives" | "negatives" | "neutrals" | "charts" | "data";
};

export default function Pizza({
  data,
  colorTheme = "charts",
  formatTooltip,
}: Props) {
  const theme = useTheme();
  const chartTheme = useChartTheme();

  function tooltip(point: PieTooltipProps<PizzaData>): JSX.Element {
    if (point.datum.id === "Sem Registros") return <></>;
    else return formatTooltip(point);
  }
  return (
    <ResponsivePie
      theme={chartTheme}
      margin={{ top: 0, right: 16, bottom: 0, left: 16 }}
      data={
        data.length > 0
          ? orderBy(data, "value", "desc")
          : ([
              {
                id: "Sem Registros",
                value: 1,
                color: alpha(theme.palette.text.secondary, 0.2),
              },
            ] as any[])
      }
      tooltip={tooltip}
      sortByValue
      innerRadius={0.6}
      // padAngle={1.6}
      // cornerRadius={8}
      colors={data.length > 0 ? getColorPalette() : { datum: "data.color" }}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      // startAngle={0}
      // endAngle={180}
      enableArcLinkLabels={false}
      arcLinkLabelsDiagonalLength={8}
      arcLinkLabelsStraightLength={0}
      arcLinkLabelsTextOffset={8}
      arcLinkLabelsSkipAngle={20}
      arcLinkLabelsTextColor={theme.palette.text.secondary}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabel={
        data.length > 0
          ? (d) => d.data.formatedLabel ?? Math.round(d.value).toString()
          : () => "Sem registros"
      }
      arcLabelsSkipAngle={20}
      // Com dado, o rótulo fica sobre o preenchimento sólido da série (tinta
      // clara). Sem dado, o arco é só um tint — a tinta tem que ser a do tema.
      arcLabelsTextColor={
        data.length > 0
          ? theme.palette.text.primaryWhite
          : theme.palette.text.secondary
      }
      animate={true}
      motionConfig="default"
      transitionMode="pushOut"
    />
  );

  function getColorPalette() {
    switch (colorTheme) {
      case "positives":
        return theme.palette.complementary.positives;
      case "negatives":
        return theme.palette.complementary.negatives;
      case "neutrals":
        return theme.palette.complementary.neutrals;
      default:
      case "charts":
        return theme.palette.charts;
      case "data":
        return { datum: "data.color" };
    }
  }
}

export interface PizzaData {
  id: string;
  label: string;
  value: number;
  formatedLabel?: string;
  aux?: any;
}
